/**
 * The `lang` attribute for a piece of free text the platform did not write (backend #690).
 *
 * `Sku.Language`, `Blog.Language` and `CustomSellerInfo.Language` say which language that row's
 * own text is written in — a seller's words and a shop's product copy are nobody's to translate,
 * so they are **tagged, never translated**. Marking them up matters because an English shop's
 * listing sits inside a German page: without a `lang` a screen reader reads English words with
 * German phonetics, and hyphenation applies the wrong rules.
 *
 * **NULL means undeclared and stays undeclared.** A scan target that declares no language must
 * not be called German just because the worker had no request language of its own — so an
 * absent tag renders **no attribute at all**, which lets the text inherit the document's
 * language rather than asserting something untrue about it.
 */
export function contentLanguage(language: string | null | undefined): string | null {
  const tag = language?.trim().toLowerCase();
  return tag ? tag : null;
}
